import { FormHelperText } from '@mui/material';
import styled from 'styled-components';

export const ErrorMessage = styled(FormHelperText)<{ $fullWidth?: boolean }>`
  margin-left: 0;
  grid-column: ${({ $fullWidth }) => ($fullWidth ? 'span 6' : '2 / span 3')};
`;
